export const WIDGET_ID = "result-funnel";
